<template>
    <div class="singlePopap" v-if="orderProduct">
        <div class="single-block-popup">
            <div class="single-block-frst">
                <div>
                    <p class="popup-text">Заполните и мы свяжемся с вами.</p>
                    <p class="popup-text">{{orderProduct.title}}</p>
                </div>
                <div class="close-block">
                    <i class="fas fa-times-circle close" @click="store.commit('TOGGLE_ORDER_POPUP', null)"></i>
                </div>   
            </div>
           
         
          <div class="contact-us-section">
            <div class="contact-us-section--inner">
            <div class="contact-us-form-box popup-contact">
                <form method="POST" @submit.prevent="submit">
                    <div class="form-single-group">
                        <div class="form-group form-order">
                            <label for="name" class="form-label">Имя</label>
                            <input type="text" id="name" name="name" class="form-input contact-input" placeholder="Введите ваше имя" v-model="name"/>
                            <label for="name" style="color: red;" class="form-label" v-if="error">{{error.errors.name}}</label>
                        </div>
                        <div class="form-group form-order">
                            <label for="email" class="form-label">Email</label>
                            <input type="text" id="email" name="email" class="form-input contact-input" placeholder="Email" v-model="email"/>
                            <label for="email" style="color: red;" class="form-label" v-if="error">{{error.errors.email}}</label>
                        </div>
                        
                    </div>
                    <div class="form-single-group ">
                        <div class="form-group form-order">
                            <label for="phone_number" class="form-label">Телефонный номер</label>
                            <input type="text" id="phone_number" name="phone_number" class="form-input" placeholder="Введите ваше Телефонный номер" v-model="phone_number"/>
                            <label for="phone_number" style="color: red;" class="form-label" v-if="error">{{error.errors.phone_number}}</label>
                        </div>
                        <div class="form-group form-order">
                            <label for="address" class="form-label">Адрес</label>
                            <input type="text" id="address" name="address" class="form-input contact-input" placeholder="Адрес" v-model="address"/>
                            <label for="address" style="color: red;" class="form-label" v-if="error">{{error.errors.address}}</label>
                        </div>
                    </div>
                    <div class="form-single-group ">
                    <div class="form-group form-order">
                        <label for="delivery_date" class="form-label">Дата доставки</label>
                        <input type="date" id="delivery_date" name="delivery_date" class="form-input contact-input" placeholder="Дата доставки" v-model="delivery_date"/>
                        <label for="delivery_date" style="color: red;" class="form-label" v-if="error">{{error.errors.delivery_date}}</label>
                    </div>
                </div>
                <div class="form-single-group ">
                    <div class="form-group form-order">
                        <label for="message" class="form-label">Сообщение</label>
                        <textarea name="message" id="message" placeholder="Введите ваше сообщение" rows="10" class="form-textarea" v-model="message"></textarea>
                        <label for="message" style="color: red;" class="form-label" v-if="error">{{error.errors.message}}</label>
                    </div>
                </div>
                        <button v-if="!isSubmited" type="submit" class="correctMassige send">Отправлять</button>
                        <p style="font-size: 20px;" class="form-label correctMassige" v-if="msg">{{msg.message}} !!!</p>
                </form>
            </div>
        </div>
          </div>    
        </div>
    </div>
</template>
<script setup>
    import {ref, defineProps, onMounted, computed} from 'vue';
    import { useStore } from 'vuex';
    const store = useStore();
    const props = defineProps(['product']);

    const name = ref(null)
    const phone_number = ref(null)
    const email = ref(null)
    const address = ref(null)
    const delivery_date = ref(null)
    const message = ref(null)
    const msg = ref(null)
    const error = ref(null)
    const isSubmited = ref(false)

    
    const orderProduct = computed(() => {
        return store.state.app.orderProduct;
    });

    async function submit(){
        try{
            error.value = '';
            isSubmited.value = true;
            const {data} = await axios.post('/make-order', {
                                                            name:name.value,
                                                            phone_number:phone_number.value,
                                                            email:email.value,
                                                            address:address.value,
                                                            delivery_date:delivery_date.value,
                                                            message:message.value,
                                                            product_id:orderProduct.value.id,
                                                            title:orderProduct.value.title,
                                                            price:orderProduct.value.price,
                                                            main_image:orderProduct.value.main_image.id,
                                                        });
            msg.value = data;
            name.value = '';
            phone_number.value = '';
            email.value = '';
            address.value = '';
            delivery_date.value = '';
            message.value = '';
        }catch(e){
            isSubmited.value = false;
            error.value = e.response.data;
        }
    }
</script>
<style setup>
.singleProduct{
    margin-top: 120px;
    color: #3c5757;
    @media screen and (max-width:500px) {
        margin-top: 145px;
    }
}
.single-block{
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 20px
}
.single-product-img-info-block {
    width: 100%;
    display: flex;
    gap: 15px;
}
.single-product-img {
    width: 50%;
    height: auto;
    border-radius: 8px;
    overflow: hidden;
}
.single-product-info-right {
    width: 50%;
    display: flex;
    flex-direction: column;
}
.button {
    width: 150px;
    height: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    background-color: #e8cc0f;
    gap: 8px;
    margin: 20px 0 30px 0;
    color:#3c5757;
    &:hover {
        background-color: #3c5757;
        color:#e8cc0f
    }
}
.single-button-text {
    font-size: 20px;
}
.product-code-block {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-bottom: 20px;
    font-size: 20px;
  
    padding-bottom: 10px;
}
@media screen and (max-width: 768px) {
        .single-product-img-info-block {
            flex-direction: column;
        }
        .single-product-img {
            width: 100%;
        }
        .single-product-info-right {
            width: 100%;
        }
        .button{
            align-self: center;
        }
    }
    .singlePopap {
    width: 100%;
    height: 100%;
    position: fixed;
    padding: 30px 0;
    top: 0;
    left:0;
    z-index: 100000;
    background-color:rgba(60, 87, 87, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 620px) {
        
    }
   
}
.singlePopap {
  color:#3c5757
}
.single-block-popup{
    overflow-x: auto;
  width: 60%;
  height: 620px;
  background-color: white;
    padding: 30px;
    border-radius: 10px;
}
.close-block {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 30px;
}
.popup-text {
  font-size: 20px;
    margin-bottom: 20px;
    @media screen and (max-width: 800px) {
        font-size: 15px;
        margin-bottom: 12px;
    }
}
.close {
  font-size: 25px;
}
.popup-contact {
  padding-left: 0 !important;
}
@media screen and (max-width: 770px) {
  .single-block-popup{
    width: 95%;
  }
}
.form-single-group{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 7px;
   margin-bottom: 16px;
    @media screen and (max-width: 600px) {
        display: block;
    }
    }
.form-order {
    margin-bottom: 0 !important;
    @media screen and (max-width: 600px) {
        margin-bottom: 16px!important;
    }
}
.single-block-frst {
    width: 100%;
    display: flex;
    justify-content: space-between;
}
</style>